/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, nthChildIterator, disable, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT DETAIL : STYLES--------------- ++++++++++ */
export default theme => ({
	detail: {
		// see reporthelpers for how these animatins tie together
		'& .areacontent': {
			display: 'flex',
			position: 'relative',
			zIndex: '1',
			// flexWrap: 'wrap',
			'& .areanav': {
				// animate in
				opacity: '0',
				animationName: 'fadeInLeft',
		        animationDuration: '.2s',
		        animationFillMode: 'forwards',
		        animationDelay: '.3s',
		        width: pxToEm(195),
				marginRight: pxToEm(25),
				'& .nav': {
					position: 'sticky',
					top: pxToEm(40),
					left: '0'
				}
			},
			'& .areasections': {
				'& section': {
					// animate in
					opacity: '0',
					animationName: 'fadeInLeft',
			        animationDuration: '.2s',
			        animationFillMode: 'forwards',
					extend: nthChildIterator(5, .3, .1),
					position: 'relative',
					'&:nth-child(1)': { zIndex: '10' },
					'&:nth-child(2)': { zIndex: '9' },
					'&:nth-child(3)': { zIndex: '8' },
					'&:nth-child(4)': { zIndex: '7' },
					'&:nth-child(5)': { zIndex: '6' },
					'&:nth-child(6)': { zIndex: '5' },
					'&:nth-child(7)': { zIndex: '4' }
				}
			}
		},
		// **** DISABLE IF PROCESSING ***** //
		'&.processing-true': {
			'& .areacontent .areasections': { extend: disable },
			'& .button:not(.processing-true)': { extend: disable }
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		detail: {
			'& .areacontent': {
				flexDirection: 'column',
				'& .areanav': {
					width: '100%',
					marginBottom: pxToEm(30)
				}
			}
		}
	}
});
